import { EnvironmentModel } from "src/app/services/environment.service";


export const environment: EnvironmentModel = {
  production: true,
  baseUrl: 'https://api.b2bendix.com',
  naStoreUrl: 'https://b2bendix.com',
  emeaStoreUrl: 'https://mytruckservices.knorr-bremse.com',
  apacStoreUrl: 'https://apac-cvs.knorr-bremse.com',
  googleReCaptchaKey: '6LdC4kkqAAAAAEuDmkMpP4hf-E6k_6pjmYABn_LG',
  oneTrustKey: '9c35cb4f-f1c2-40af-9af4-59b11f785f37',
  webtrekk: {
    trackId: "390993738581837",
    trackDomain: "website-usage.knorr-bremse.com"
  },
  serverLoggingUrl: 'https://api.catnw8-knorrbrem1-p1-public.model-t.cc.commerce.ondemand.com/occ/v2/NA/ui-logs'
};
